export function handleExtensionsList(isDeviceMatch, preferences) {
  return function({
    config,
    ...rest
  }) {
    const opts = config.settings_options;
    const mapExtensionDisplayNames = opts.reduce((map, option) => {
      return map.set(option.name, option.display_name);
    }, new Map());

    // filter extensions list to match current device and ...
    config.extensions = config.extensions
      .filter((extension) => isDeviceMatch(extension.options?.vendors_list));

    // fill preference repo with available types
    // and extend config with saved user preferences
    config.extensions
      .forEach((extension) => {
        const preference = preferences.create({
          name: extension.name,
          display_name: mapExtensionDisplayNames.get(extension.name)
        });
        extension.allowed = preference.enable;
        // redundant, remaining from deprecated "disable on first view"
        extension.isConfirmed = preference.isConfirmed;
      });

    return {
      ...rest,
      config,
    };
  };
}
